import { IntrinsicProps, createComponent } from '@common/util/templateHelpers';
import style from './index.module.scss';
import { Block } from 'react-commons';

interface ArticleContentProps extends IntrinsicProps {
  html: string
}

export default createComponent<ArticleContentProps>('ArticleContent', { style }, function ArticleContent ({ className, style }, props) {
  return (
    <Block className={className}>
      <div 
        style={style} 
        dangerouslySetInnerHTML={{ __html: props.html }}
      />
    </Block>
  );
});
